import { BaseResponse, IGetClientResModule } from '@msg91/models/root-models';
import { IAdminMeData } from '@msg91/models/super-admin-models';
import { createAction, props } from '@ngrx/store';

export const headerTitleAction = createAction('[set header name] Header Title Action ', props<{ title: string }>());

export const getClientAction = createAction('[Get Client] Get Client', props<{ request: any }>());
export const getClientActionComplete = createAction(
    '[Get Client] Get Client Complete',
    props<{ response: BaseResponse<IGetClientResModule[], any> }>()
);
export const getClientActionError = createAction('[Get Client] Get Client Error', props<{ errors: string[] }>());

export const setSelectedClient = createAction(
    '[Get Client] Set Selected Client',
    props<{ response: IGetClientResModule }>()
);
export const setShowClientList = createAction('[Get Client] Set Show Client List', props<{ response: boolean }>());
export const setSideBarToggleStatus = createAction('Set Side Bar Toggle Status', props<{ status: boolean }>());

export const getUserInboundEmailPermission = createAction('[Email] Get User Inbound Email Permission');
export const getUserInboundEmailPermissionSuccess = createAction(
    'Get User Inbound Email Permission Success',
    props<{ payload: string[] }>()
);

export const setFCMToken = createAction('[Root] Set FCM Token', props<{ token: string }>());
export const setDateRange = createAction('[Root] Set Date Range', props<{ dateRange: any }>());
export const setSelectedWhatsappNumber = createAction(
    '[General] Set WhatsappNumber',
    props<{ response: number | null }>()
);
export const setIntegratedFbCloudNumbers = createAction(
    '[whats app] integrated fb cloud numbers',
    props<{ integratedFbNumbers: string[] }>()
);
export const setIntegratedHaptikNumbers = createAction(
    '[whats app] haptik wa integrated numbers',
    props<{ integratedHaptikNumbers: string[] }>()
);
export const setAllWhatsAppIntegratedNumbers = createAction(
    '[whats app] all wa integrated numbers',
    props<{ allWhatsAppIntegratedNumbers: string[] }>()
);
export const setIntegrated360Numbers = createAction(
    '[whats app] integrated 360 numbers',
    props<{ numbers: string[] }>()
);

export const getAdminMe = createAction('[Admin Me] Get Admin Me');
export const getAdminMeSuccess = createAction('[Admin Me] Get Admin Me Success', props<{ payload: IAdminMeData }>());
export const getAdminMeError = createAction('[Admin Me] Get Admin Me Error', props<{ errors: string[] }>());
